<template lang="pug">
    
div(
    :class="$style.root"
)
    div(
        :class="$style.name"
    ) {{ name }}
    div(
        :class="$style.value"
    ) {{ filteredValue }}
        IconBase(
            v-if="isCurrency"
            :color="'inherit'"
            :name="'icon-currency-som'"
            size="10"
        )
        
</template>

<script lang="ts">
import Vue from 'vue'

import { IconBase } from '@/shared/ui/IconBase'

export default Vue.extend({
    name: 'AmountCell',
    components: { IconBase },
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
    },
    computed: {
        isCurrency() {
            return /[\u0020\u00A0][СC]$/.test(this.value)
        },
        filteredValue() {
            return this.value.replace(/[\u0020\u00A0][СC]$/, '')
        },
    },
})
</script>

<style module lang="scss">
.root {
    display: flex;
    justify-content: space-between;
    gap: rem(12);
    align-items: center;
    @include fontSize(infoM);
}

.value {
    flex-shrink: 0;
    display: flex;
    gap: 4px;
    align-items: center;
}
</style>
